import React, { useRef, useState } from "react";
import Layout from "components/Layout";
import { Flex, Box, Text } from "@chakra-ui/react";
import Image from "components/Image";
import whatsAppImage from "../../../public/whatsapp.png";
import linkedInImage from "../../../public/linkedin.png";
import rajivAvatarImage from "../../../public/contact/rajiv-avatar.png";
import ranaAvatarImage from "../../../public/contact/rana-avatar.png";
import bgCircle from "../../../public/contact/bg-circle.svg";
import Head from "next/head";
import FormContact from "containers/FormContact";
import Button from "components/Button";
import FormContactNotification from "containers/FormContact/FormContactNotification";

const Contact: React.FC = () => {
  const [sentEmail, setSentEmail] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);
  const refSuccessfullyMessage = useRef<HTMLParagraphElement>(null);
  const refErrorMessage = useRef<HTMLParagraphElement>(null);

  return (
    <Layout>
      <Head>
        <title>101Digital | Contact</title>
      </Head>
      <Text
        as="h1"
        textStyle="h1"
        fontSize={["36px", null, null, null, null, "72px"]}
        lineHeight="85px"
        textAlign={["center", null, null, null, null, "left"]}
        mb={["0px", null, null, null, null, "19px"]}
        mt={["25px", null, null, null, null, "46px"]}
        display={["block", null, null, null, null, "none"]}
      >
        <Text>Let&apos;s Talk!</Text>
      </Text>
      <Text
        textStyle="paragraphHighlighted"
        textAlign={["center", null, null, null, null, "left"]}
        px={["49px", null, null, null, null, "0px"]}
        mb={["92px", null, null, null, null, "84px"]}
        fontWeight="300"
        display={["block", null, null, null, null, "none"]}
      >
        Time to build a great digital product and take it to market! Submit your
        details, and we will get in touch.
      </Text>
      <Flex
        p={[
          0,
          null,
          null,
          null,
          null,
          "97px 2% 231px 6%",
          "97px 4% 231px 12%",
          null,
          "97px 8% 231px 16%",
          "97px 13.8% 231px 19.375%",
        ]}
        mt={[0, null, null, null, null, "52px"]}
        pos="relative"
        flexDir={["column-reverse", null, null, null, null, "row"]}
        w="100%"
      >
        <Box
          pos="absolute"
          top={0}
          right={["-117px", null, null, "0"]}
          zIndex="-1"
        >
          <Image src={bgCircle} alt="101d" />
        </Box>
        <Box pr={[0, null, null, null, null, "66px"]}>
          <Text
            as="h1"
            textStyle="h1"
            fontSize={["36px", null, null, null, null, "72px"]}
            lineHeight="85px"
            textAlign={["center", null, null, null, null, "left"]}
            mb={["0px", null, null, null, null, "19px"]}
            mt={["72.26px", null, null, null, null, "46px"]}
            display={["none", null, null, null, null, "block"]}
          >
            <Text>Let&apos;s Talk!</Text>
          </Text>
          <Text
            textStyle="paragraphHighlighted"
            textAlign={["center", null, null, null, null, "left"]}
            px={["49px", null, null, null, null, "0px"]}
            mb={["92px", null, null, null, null, "84px"]}
            fontWeight="300"
            display={["none", null, null, null, null, "block"]}
          >
            Time to build a great digital product and take it to market! Submit
            your details, and we will get in touch.
          </Text>
          <Flex
            alignItems="center"
            mb={["23.21px", null, null, null, null, "14px"]}
            justify={["center", null, null, null, null, "flex-start"]}
          >
            <Box
              w={["31.87px", null, null, null, null, "auto"]}
              h={["34.72px", null, null, null, null, "auto"]}
            >
              <Image src={whatsAppImage} alt="101D" />
            </Box>
            <Text
              as="h2"
              textStyle="h2"
              fontSize={["18px", null, null, null, null, "36px"]}
              lineHeight={["36.12px", null, null, null, null, "85px"]}
              ml={["9.77px", null, null, null, null, "23px"]}
            >
              Connect on Whatsapp
            </Text>
          </Flex>
          <Text
            textStyle="paragraph"
            mb={["49.01px", null, null, null, null, "22.67px"]}
            whiteSpace="pre-line"
            fontSize={["14px", null, null, null, null, "22px"]}
            color="primary"
            textAlign={["center", null, null, null, null, "left"]}
            fontWeight={300}
            lineHeight={["17.21px", null, null, null, null, "40.5px"]}
          >
            You can also speak to our founders directly. {`\n`}That&apos;s how
            approachable we are!
          </Text>
          <Flex
            flexDir={["column", null, null, null, null, "row"]}
            mb={["88.65px", null, null, null, null, "0px"]}
            justify={["center", null, null, null, null, "flex-start"]}
            alignItems={["center", null, null, null, null, "flex-start"]}
          >
            <Flex
              alignItems="center"
              mb={["30.89px", null, null, null, null, "0px"]}
              onClick={() => window.open("https://wa.me/6583390399", "_blank")}
              cursor="pointer"
              mr={["0px", null, null, null, null, "77.67px"]}
            >
              <Image src={ranaAvatarImage} alt="101D" />
              <Text
                textStyle="paragraph"
                ml={["30.72px", null, null, null, null, "36px"]}
                color="primary"
              >
                Rana
              </Text>
            </Flex>
            <Flex
              alignItems="center"
              onClick={() => window.open("https://wa.me/6583390388", "_blank")}
              cursor="pointer"
            >
              <Image src={rajivAvatarImage} alt="101D" />
              <Text
                textStyle="paragraph"
                ml={["30.72px", null, null, null, null, "36px"]}
                color="primary"
              >
                Rajiv
              </Text>
            </Flex>
          </Flex>
        </Box>
        <Box
          px={["20px", null, null, null, null, "0px"]}
          width="100%"
          maxW="641px"
          m="auto"
        >
          <FormContactNotification
            ref={refSuccessfullyMessage}
            state={sentEmail}
            setState={setSentEmail}
            message={`Thank you for your inquiry!${"\n"}We will get back to you as soon as possible.`}
          />
          <FormContactNotification
            ref={refErrorMessage}
            state={error}
            setState={setError}
            message={`There was an error trying to send your message${"\n"}Please try again later.`}
          />
          <Box
            width="100%"
            p={["51px 25px", null, null, null, null, "64px 40px"]}
            border="1px solid #D2D2F5"
            boxShadow="0px 5px 20px rgba(0, 0, 0, 0.25)"
            borderRadius="10px"
            bgColor="#ffffff"
            mb={["99px", null, null, null, null, "0px"]}
            display={sentEmail || error ? "none" : "block"}
          >
            <FormContact
              refSuccessfullyMessage={refSuccessfullyMessage}
              refErrorMessage={refErrorMessage}
              setError={setError}
              setSentEmail={setSentEmail}
            />
          </Box>
        </Box>
      </Flex>

      <Flex
        flexDir="column"
        alignItems="center"
        w="100%"
        bgColor="primary"
        bgImage="url('/circuit-board-blue-small.png')"
        p={["46.85px 0px 36px", null, null, null, null, "87px 0px 67px"]}
      >
        <Text
          color="white"
          as="h2"
          textStyle="h2"
          lineHeight={["20px", null, null, null, null, "54px"]}
          fontSize={["14px", null, null, null, null, "36px"]}
          mb={["36px", null, null, null, null, "64px"]}
          textAlign="center"
          maxW={["255px", null, null, null, null, "unset"]}
          whiteSpace={["normal", null, null, null, null, "pre-line"]}
        >
          Follow us to know the latest FinTech developments, product {`\n`}{" "}
          roadmaps, and customer success stories.
        </Text>
        <Box
          w={["54px", null, null, null, null, "83px"]}
          h={["54px", null, null, null, null, "83px"]}
          cursor="pointer"
          onClick={() =>
            window.open(
              "https://www.linkedin.com/company/101digital/",
              "_blank"
            )
          }
        >
          <Image src={linkedInImage} alt="101D" />
        </Box>
      </Flex>
    </Layout>
  );
};

export default Contact;
